import { createStore } from 'vuex'


import logs from '@/store/modules/logs'
import AppConfig from '@/store/modules/AppConfig'
import User from '@/store/modules/User'
import Card from '@/store/modules/Card'

export default createStore({
  state: {
      ShowPopupCookie:false,
      ShowBTStart:false,
      // ShowPopupTerm:false
  },
  mutations: {
    SavePopupCookies(state,payload){
      state.ShowPopupCookie = payload
    },
    SetBTStart(state,payload){
      state.ShowBTStart = payload
    },
    // SavePopupTerm(state,payload){
    //   state.ShowPopupTerm = payload
    // }
  },
  actions: {
    SetPopupCookie({commit},payload){
      commit('SavePopupCookies', payload)
    },
    SetBTStart({commit},payload){
      commit('SetBTStart', payload)
    },
    // SetPopupTerm({commit},payload){
    //   commit('SavePopupTerm', payload)
    // }
  },
  getters: {
    GetPopupCookies: (state) => state.ShowPopupCookie,
    GetBTStart: (state) => state.ShowBTStart,
    // GetPopupTerm: (state) => state.ShowPopupTerm,
  },
  modules: {
    logs,
    AppConfig,
    User,
    Card
  }
})
